import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogComposerAttachmentsInvalid from './VeltCommentDialogComposerAttachmentsInvalid/VeltCommentDialogComposerAttachmentsInvalid';
import VeltCommentDialogComposerAttachmentsSelected from './VeltCommentDialogComposerAttachmentsSelected/VeltCommentDialogComposerAttachmentsSelected';
import { transformWireframeProps } from '../../../../utils/propUtils';
;
var VeltCommentDialogComposerAttachments = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachments.Invalid = VeltCommentDialogComposerAttachmentsInvalid;
VeltCommentDialogComposerAttachments.Selected = VeltCommentDialogComposerAttachmentsSelected;
export default VeltCommentDialogComposerAttachments;
